fx.ns("models", class Lang extends fx.Model {

	constructor(data)
	{
		super(data);
    }

    get defaults()
	{
		return {
			vat: 20
		}
	}

    get tax()
    {
        return 1 + (this.vat / 100); 
    }
});
